var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"event-row__footer-content"},[_c('i',{staticClass:"icon--sm icon-arrow_new_line event-row__footer-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.props.content))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664f0570","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/eventGrid/components/MatchFooterRow.vue
// module id = 2067
// module chunks = 0